import { ChannelRow } from './channel';
import { PCImage } from 'app/design/primitives/image';
import type { GroupChannel as GroupChannelType, SupportChannel as SupportChannelType } from 'app/types/chat';
import { createTheme as createDSTheme } from 'app/shopify';
import {
  isTransportSupportChannel,
  TransportSupportAvatar,
} from 'app/screens/chat/components/transport-support-avatar';
const theme = createDSTheme();

const SupportChannel = function SupportChannel(channel: SupportChannelType | GroupChannelType) {
  const showTransportSupportAvatar = isTransportSupportChannel(channel);

  return (
    <ChannelRow
      channel={channel}
      prefix={
        showTransportSupportAvatar ? (
          <TransportSupportAvatar size={60} />
        ) : (
          <PCImage
            aspectRatio={1}
            height={60}
            source={{ uri: channel.picture }}
            style={{ borderRadius: theme.borderRadii['radius.lg'] }}
          />
        )
      }
    />
  );
};

export { SupportChannel };
